import { lazy } from 'react';

// Lazy load franchise pages (they include FranchiseCalendarBooking which is heavy)
export const Franchise = lazy(() => import("@/pages/Franchise"));
export const FranchiseUSA = lazy(() => import("@/pages/franchise/FranchiseUSA"));
export const FranchiseCanada = lazy(() => import("@/pages/franchise/FranchiseCanada"));
export const FranchiseUK = lazy(() => import("@/pages/franchise/FranchiseUK"));
export const FranchiseUAE = lazy(() => import("@/pages/franchise/FranchiseUAE"));
export const FranchiseSingapore = lazy(() => import("@/pages/franchise/FranchiseSingapore"));
export const FranchiseNewZealand = lazy(() => import("@/pages/franchise/FranchiseNewZealand"));
export const MasterFranchiseInfoPack = lazy(() => import("@/pages/franchise/MasterFranchiseInfoPack"));
export const VicFranchiseInfoPack = lazy(() => import("@/pages/franchise/VicFranchiseInfoPack"));


// Lazy load other heavy pages
export const ScopeExam = lazy(() => import("@/pages/ScopeExam"));
export const ScopeRegistration = lazy(() => import("@/pages/ScopeRegistration"));
export const ScopeRegistrationColebee = lazy(() => import("@/pages/ScopeRegistrationColebee"));
export const ColebeeEnrolment = lazy(() => import("@/pages/ColebeeEnrolment"));
export const ScopeRegistrationRiverston = lazy(() => import("@/pages/ScopeRegistrationRiverston"));

export const ScopeRegistrationThePonds = lazy(() => import("@/pages/ScopeRegistrationThePonds"));
export const ScopeRegistrationCarolineSprings = lazy(() => import("@/pages/ScopeRegistrationCarolineSprings"));
export const ScopeRegistrationTruganina = lazy(() => import("@/pages/ScopeRegistrationTruganina"));
export const BootcampRegistrationRiverston = lazy(() => import("@/pages/BootcampRegistrationRiverston"));
export const BootcampRegistrationPenrith = lazy(() => import("@/pages/BootcampRegistrationPenrith"));
export const NswSelectiveCalculator = lazy(() => import("@/pages/NswSelectiveCalculator"));
export const NswOcCalculator = lazy(() => import("@/pages/NswOcCalculator"));
export const Newsroom = lazy(() => import("@/pages/Newsroom"));
export const TmrwLeap = lazy(() => import("@/pages/TmrwLeap"));
export const BooksMaterials = lazy(() => import("@/pages/BooksMaterials"));
export const ParentGuides = lazy(() => import("@/pages/ParentGuides"));
export const ScholarshipExamCourse = lazy(() => import("@/pages/ScholarshipExamCourse"));
export const ScholarshipExamProviders = lazy(() => import("@/pages/ScholarshipExamProviders"));
export const VsecProgram = lazy(() => import("@/pages/VsecProgram"));
export const Careers = lazy(() => import("@/pages/Careers"));
export const Awards = lazy(() => import("@/pages/Awards"));
export const MobileApp = lazy(() => import("@/pages/MobileApp"));
export const SchooAI = lazy(() => import("@/pages/SchooAI"));
export const SchoololaAcademy = lazy(() => import("@/pages/SchoololaAcademy"));
export const FAQ = lazy(() => import("@/pages/FAQ"));
export const Sitemap = lazy(() => import("@/pages/Sitemap"));
export const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
export const TermsConditions = lazy(() => import("@/pages/TermsConditions"));
export const PartnerAccessHub = lazy(() => import("@/pages/PartnerAccessHub"));
export const KeyDifferentiators = lazy(() => import("@/pages/KeyDifferentiators"));
export const OurStory = lazy(() => import("@/pages/OurStory"));
export const ExecutiveTeam = lazy(() => import("@/pages/ExecutiveTeam"));
export const ServiceAreas = lazy(() => import("@/pages/ServiceAreas"));
export const Values = lazy(() => import("@/pages/Values"));
